import React from "react";
import { BorderProps, ColorProps, SpaceProps, LayoutProps, variant } from "styled-system";
import styled from "styled-components";
import { Box } from "../Box";
import { Link } from "../Link";
import { LinkButtonProps as Props } from "./index";

export const MockButton = styled(Box)(
  {
    "box-sizing": "border-box",
  },
  variant({
    scale: "linkButtons",
    variants: {
      primary: {
        bg: "primary",
        color: "white",
        borderColor: "primary",
      },
      accent: {
        bg: "accent",
        color: "white",
        borderColor: "accent",
      },
      outlined: {
        color: "primary",
        bg: "transparent",
        borderColor: "primary",
      },
      transparent: {
        color: "accent",
        bg: "transparent",
        borderColor: "transparent",
      },
    },
  }),
);

export const LinkButton: React.FC<Props & LayoutProps & ColorProps & BorderProps & SpaceProps> = ({
  href,
  target = "_blank",
  gaTrack,
  children,
  ...restProps
}) => {
  const tracking = gaTrack || { label: children };
  return (
    <Box width={["auto", "auto", "216px", "216px", "216px"]}>
      <Link data-testid="LinkButton" href={href} gaTrack={tracking} target={target}>
        <MockButton textAlign="center" border="2px solid" borderRadius={4} p="14px" variant="accent" fontSize={2} {...restProps}>
          {children}
        </MockButton>
      </Link>
    </Box>
  );
};
